import {FormGroup} from "@angular/forms";
import {DetailConfigurationField} from "../../../models/detail-configuration-field";


export class Field
{


    /**
     * Attributes
     */
    OBJ_field_config: DetailConfigurationField;
    OBJ_form_group: FormGroup;
    STR_dependent_fields = '';
    BOO_one_dependent_field = true;


    /**
     * Function > isInvalid
     * @return {boolean}
     */
    isInvalid(): boolean
    {
        let OBJ_form_control = this.OBJ_form_group.get(this.OBJ_field_config.name);
        if(OBJ_form_control !== null)
		{
			return OBJ_form_control.invalid /*&& (OBJ_form_control.dirty||OBJ_form_control.touched)*/;
		} // end if

        return true;

    } // end function isInvalid


    /**
     * Function > getLabelName
     * @return {string}
     */
    getLabelName(): string
    {

    	// if field has external object take its title not title of config
	    // this way publicationobjects can be named more specifically
    	if (
		    this.OBJ_field_config.object_structure &&
			this.OBJ_field_config.object_structure.classname === "\\Infinity\\Models\\Entities\\Applications\\Publicationobject" &&
			this.OBJ_field_config.object_structure.title
	    )
		{
			return this.OBJ_field_config.object_structure.title;
		} // end if
        return (this.OBJ_field_config.label||this.OBJ_field_config.name.toLocaleLowerCase());

    } // end Function getLabelName


	/**
	 * Function > getLabelName
	 * @var object OBJ_option
	 * @return {string}
	 */
	getLabelNameOption(OBJ_option): string
	{
		return (OBJ_option.label||OBJ_option.name);
	} // end Function getLabelNameOption


    /**
     * Function > getHint
     * @return {string}
     */
    getHint(): string
    {

        let STR_hint = "";
        if (this.OBJ_field_config.hint)
        {

            // hint is given directly via config
            if (typeof(this.OBJ_field_config.hint) == "string")
            {
                STR_hint = this.OBJ_field_config.hint;
            }
            else
            {
                // create hint with prefix from name or label
                STR_hint = ((this.OBJ_field_config.label||this.OBJ_field_config.name) + "_hint").toLocaleLowerCase();
            } // end if

        } // end if
        return STR_hint;

    } // end Function getHint


    /**
     * Function > getDependentFields
     * @param OBJ_translate_service
     */
    getDependentFields(OBJ_translate_service)
    {

        let STR_prefix = '';
        if (typeof this.OBJ_field_config.label !== 'undefined')
        {
            let ARR_split = this.OBJ_field_config.label.split('.');
            STR_prefix = ARR_split[0] + '.s';
        } // end if

        // collect all fields that depend on this field to display a warning
        if (this.OBJ_field_config.dependent_fields)
        {

            this.BOO_one_dependent_field = this.OBJ_field_config.dependent_fields.length === 1;
            for (let INT_idx = 0; INT_idx < this.OBJ_field_config.dependent_fields.length; INT_idx++)
            {

                let ARR_split = this.OBJ_field_config.dependent_fields[INT_idx].split('.'),
                    STR_translate = ARR_split[0];

                if (STR_prefix.length > 0 )
                {
                    STR_translate = STR_prefix + Field.ucFirst(ARR_split[0]);
                }
                this.STR_dependent_fields += OBJ_translate_service.instant(STR_translate) + ", ";

            } // end for

        } // end if

        // remove last 2 characters
        this.STR_dependent_fields = this.STR_dependent_fields.slice(0, -2);

    } // end function getDependentFields

    /**
     * Function > isRequired
     */
    isRequired()
    {
        if(this.OBJ_field_config.validators)
        {
            for (let OBJ_validator of this.OBJ_field_config.validators) {

                if(OBJ_validator.type === 'required')
                {
                    return true;
                } // end if

            } // end for

        } // end if

        return false;
    } // end function isRequired

	/**
	 * Function > isNew
	 * @desc Markiere neu hinzugekommene Felder
	 */
	isNew()
	{
		return this.OBJ_field_config.new;
	} // end function isNew

    static ucFirst(string)
    {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

	/**
	 * Function > getFormControl
	 */
	getFormControl()
    {
        return this.OBJ_form_group.get(this.OBJ_field_config.name);
    } // end function getFormControl

	/**
	 * Function > getFormControl
	 */
	getFieldConfig()
	{
		return this.OBJ_field_config;
	} // end function getFormControl

	/**
	 * Function > getFormControlByName
	 * @param STR_formcontrol
	 */
	getFormControlByName(STR_formcontrol)
	{
		return this.OBJ_form_group.get(STR_formcontrol);
	} // end function getFormControlByName

    /**
     * Function > getFormGroup
     * @desc Gibt Fromgroup mit uebergebenem Namen zurueck
     */
    getFormGroup(): FormGroup
    {
        return this.OBJ_form_group.get(this.OBJ_field_config.name) as FormGroup;
    } // end function getFormGroup

    /**
     * Function > setValue
     * @param MIX_value
     * @return void
     */
    setValue(MIX_value: any): void
    {
        this.OBJ_field_config.value = MIX_value;
    } // end function setValue

    /**
     * Function markAsDirtyAndTouched
     * @desc Mark an edited field as dirty and touches - often necessary for custom form elements to prevent user leaving the page with unsaved changes
     */
    markAsDirtyAndTouched()
    {
        let OBJ_form_control = this.getFormControl();
        OBJ_form_control.markAsDirty();
        OBJ_form_control.markAsTouched();
    } // end function markAsDirtyAndTouched


} // end interface Field
